import script from "./RenameItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameItem.vue?vue&type=script&setup=true&lang=js"

import "./RenameItem.vue?vue&type=style&index=0&id=19fda4ae&lang=css"

const __exports__ = script;

export default __exports__